import {
  LOG_OUT,
  ACCESSIBILITY_TYPE,
  DRESS_CODE_TYPE,
  PARKING_TYPE,
  PAYMENT_METHOD_TYPE,
  PET_ALLOWANCE_TYPE,
  RESTAURANT_TYPE,
  RESTAURANT_CHAIN,
  RESTAURANT_FEATURES,
  LOCATED_INSIDE,
  POINT_OF_SALE,
  HEALTH_ENTRY_POINT,
  HEALTH_INSIDE_FACILITY,
  HEALTH_EMPLOYEES,
  HEALTH_FOOD_HANDLE,
  HEALTH_AND_SAFETY,
  OTHER_FEATURES,
  SERVICES_OFFERED,
  FOOD_CATEGORY,
  FOOD_TYPE,
  LIQUORS,
  CUISINES,
  SEATING_AREA,
  ALLERGY_INFORMATION,
  TAGS_INFORMATION,
  UOM_INFORMATION,
  BEVERAGES_TYPE,
  CATEGORY_CLASSIFICATION,
  MAJOR_CLASSIFICATION,
  HEALTH_TAGS,
} from "../../types";

const initialState = {
  accessibility_type: [],
  dress_code: [],
  parking_type: [],
  payment_method_type: [],
  pet_allowance_type: [],
  restaurant_type: [],
  restaurant_chain: [],
  restaurant_features: [],
  located_inside: [],
  point_of_sale: [],
  health_entry_point: [],
  health_inside_facility: [],
  health_employees: [],
  health_handling: [],
  heath_and_safety: [],
  other_features: [],
  services_offered: [],
  foodcategory: [],
  foodtype: [],
  liquorcategory: [],
  cusine: [],
  seating_area: [],
  allergy_info: [],
  tags_info: [],
  uom_info: [],
  beverages_type: [],
  category_classification: [],
  major_classification: [],
  health_tags: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ACCESSIBILITY_TYPE:
      return {
        ...state,
        accessibility_type: action.payload,
      };
    case DRESS_CODE_TYPE:
      return {
        ...state,
        dress_code: action.payload,
      };
    case PARKING_TYPE:
      return {
        ...state,
        parking_type: action.payload,
      };
    case PAYMENT_METHOD_TYPE:
      return {
        ...state,
        payment_method_type: action.payload,
      };
    case PET_ALLOWANCE_TYPE:
      return {
        ...state,
        pet_allowance_type: action.payload,
      };
    case RESTAURANT_TYPE:
      return {
        ...state,
        restaurant_type: action.payload,
      };
    case RESTAURANT_CHAIN:
      return {
        ...state,
        restaurant_chain: action.payload,
      };
    case RESTAURANT_FEATURES:
      return {
        ...state,
        restaurant_features: action.payload,
      };
    case LOCATED_INSIDE:
      return {
        ...state,
        located_inside: action.payload,
      };
    case POINT_OF_SALE:
      return {
        ...state,
        point_of_sale: action.payload,
      };
    case HEALTH_ENTRY_POINT:
      return {
        ...state,
        health_entry_point: action.payload,
      };
    case HEALTH_INSIDE_FACILITY:
      return {
        ...state,
        health_inside_facility: action.payload,
      };
    case HEALTH_EMPLOYEES:
      return {
        ...state,
        health_employees: action.payload,
      };
    case HEALTH_FOOD_HANDLE:
      return {
        ...state,
        health_handling: action.payload,
      };
    case HEALTH_AND_SAFETY:
      return {
        ...state,
        heath_and_safety: action.payload,
      };
    case OTHER_FEATURES:
      return {
        ...state,
        other_features: action.payload,
      };
    case SERVICES_OFFERED:
      return {
        ...state,
        services_offered: action.payload,
      };
    case FOOD_CATEGORY:
      return {
        ...state,
        foodcategory: action.payload,
      };
    case FOOD_TYPE:
      return {
        ...state,
        foodtype: action.payload,
      };
    case LIQUORS:
      return {
        ...state,
        liquorcategory: action.payload,
      };
    case CUISINES:
      return {
        ...state,
        cusine: action.payload,
      };
    case SEATING_AREA:
      return {
        ...state,
        seating_area: action.payload,
      };
    case ALLERGY_INFORMATION:
      return {
        ...state,
        allergy_info: action.payload,
      };
    case TAGS_INFORMATION:
      return {
        ...state,
        tags_info: action.payload,
      };
    case UOM_INFORMATION:
      return {
        ...state,
        uom_info: action.payload,
      };
    case BEVERAGES_TYPE:
      return {
        ...state,
        beverages_type: action.payload,
      };
    case CATEGORY_CLASSIFICATION:
      return {
        ...state,
        category_classification: action.payload,
      };
    case MAJOR_CLASSIFICATION:
      return {
        ...state,
        major_classification: action.payload,
      };
    case HEALTH_TAGS:
      return {
        ...state,
        health_tags: action.payload,
      };

    // case LOG_OUT: {
    //   return {
    //     ...state,
    //     accessibility_type: [],
    //     dress_code: [],
    //     parking_type: [],
    //     payment_method_type: [],
    //     pet_allowance_type: [],
    //     restaurant_type: [],
    //     restaurant_chain: [],
    //     restaurant_features: [],
    //     located_inside: [],
    //     point_of_sale: [],
    //     health_entry_point: [],
    //     health_inside_facility: [],
    //     health_employees: [],
    //     health_handling: [],
    //     heath_and_safety: [],
    //     other_features: [],
    //     services_offered: [],
    //     foodcategory: [],
    //     foodtype: [],
    //     liquorcategory: [],
    //     cusine: [],
    //     seating_area: [],
    //     allergy_info: [],
    //     tags_info: [],
    //   };
    // }
    default:
      return state;
  }
}
